/* ═══════════════════════════════════════════
   BRACELET BUILDER — Charmtastic
   Standalone JS, config injected via #bldConfig JSON
   ═══════════════════════════════════════════ */
(function() {
  'use strict';

  var configEl = document.getElementById('bldConfig');
  if (!configEl) return;
  var CFG = JSON.parse(configEl.textContent);

  /* Currency-aware price formatter — renders the shopper's active presentment
     currency (or USD when Shopify's converter has no rate for it and falls back
     to USD). Shopify stores money as an integer ×100 even for zero-decimal
     currencies (IDR/JPY), so always ÷100; Intl applies the right decimals. */
  var _bldNf; try { _bldNf = new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }); } catch(e) {}
  function money(c) { return _bldNf ? _bldNf.format(c / 100) : '$' + (c / 100).toFixed(2); }
  /* Shop→shopper FX rate. Charm prices come from Liquid already in the shopper's
     currency, but the base-bracelet price is a fixed customizer setting in the
     shop's base currency, so convert it so the total doesn't mix currencies. */
  var _bldRate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;

  /* ═══ CONFIG ═══ */
  /* Categories are defined by editor blocks now (CFG.categories). Each:
     { id, label, scope:'any'|'pendants'|'gold', keywords:'a,b', tags:'x,y', exclude:'z' }.
     We parse the comma strings into arrays once. */
  function splitList(s) {
    if (!s) return [];
    return String(s).toLowerCase().split(',').map(function(x){ return x.trim(); }).filter(Boolean);
  }
  /* whole-word (word-START) match: "cat" matches "cat/cats/category" but NOT
     "vacation"; "heart" still matches "hearts". Avoids substring collisions. */
  function hasWord(text, kw) {
    var i = text.indexOf(kw);
    while (i > -1) {
      var before = i === 0 ? '' : text.charAt(i - 1);
      if (!/[a-z0-9]/.test(before)) return true;
      i = text.indexOf(kw, i + 1);
    }
    return false;
  }
  var CATS = (CFG.categories || []).map(function(c) {
    return {
      id: String(c.id),
      label: c.label || '',
      scope: c.scope || 'any',
      keywords: splitList(c.keywords),
      tags: splitList(c.tags),
      exclude: splitList(c.exclude)
    };
  });
  function getCat(id) {
    for (var i = 0; i < CATS.length; i++) { if (CATS[i].id === String(id)) return CATS[i]; }
    return null;
  }
  /* which collection a category needs loaded (scope-based) */
  function catCollection(cat) {
    if (cat && cat.scope === 'gold') return 'golden-charms';
    if (cat && cat.scope === 'pendants') return 'pandants-charms';
    return 'charms';
  }
  /* does a charm belong to a category's scope pool? */
  function inScope(charm, scope) {
    if (scope === 'pendants') return charm.collection === 'pandants-charms';
    if (scope === 'gold') return charm.collection === 'golden-charms' || charm.tags.indexOf('gold') > -1;
    return true;
  }
  var SILVER_VARIANT = CFG.silverVariantId;
  var GOLD_VARIANT = CFG.goldVariantId;
  var BASE_PRICE = Math.round(CFG.basePrice * _bldRate);
  var DISC_TIERS = [
    { min: CFG.tier1Count, pct: CFG.tier1Pct },
    { min: CFG.tier2Count, pct: CFG.tier2Pct },
    { min: CFG.tier3Count, pct: CFG.tier3Pct }
  ];
  var BLANK_SILVER = CFG.blankSilver;
  var BLANK_GOLD = CFG.blankGold;

  /* ═══ DOUBLE & CHAIN CHARMS ═══
     DOUBLE = occupies 2 ADJACENT links (head {w:2} + continuation {cont}).
     CHAIN  = occupies 2 links with ONE usable link BETWEEN them (head {chain,mate}
              + far end {chainEnd,of}); a chain graphic is drawn across the gap.
     Detected by title: chain wins over double. */
  var DOUBLE_KW = splitList(CFG.doubleKeywords != null ? CFG.doubleKeywords : 'double');
  var DOUBLE_TAGS = splitList(CFG.doubleTags || '');
  function isDoubleProduct(title, tags) {
    var t = (title || '').toLowerCase();
    for (var i = 0; i < DOUBLE_KW.length; i++) { if (hasWord(t, DOUBLE_KW[i])) return true; }
    for (var j = 0; j < DOUBLE_TAGS.length; j++) { if (tags && tags.indexOf(DOUBLE_TAGS[j]) > -1) return true; }
    return false;
  }
  /* ═══ PENDANTS ═══
     A pendant hangs BELOW the bracelet link (rendered as an overlay) instead of
     sitting flat on it. Being in the 'pandants-charms' collection already marks a
     charm as a pendant, but the SAME charm can also surface in a themed category
     (loaded from the 'charms' collection) — there it must still hang. So we also
     let a title keyword / product tag flag it as a pendant. */
  var PENDANT_KW = splitList(CFG.pendantKeywords != null ? CFG.pendantKeywords : 'pendant');
  var PENDANT_TAGS = splitList(CFG.pendantTags || '');
  function isPendantProduct(title, tags) {
    var t = (title || '').toLowerCase();
    for (var i = 0; i < PENDANT_KW.length; i++) { if (hasWord(t, PENDANT_KW[i])) return true; }
    for (var j = 0; j < PENDANT_TAGS.length; j++) { if (tags && tags.indexOf(PENDANT_TAGS[j]) > -1) return true; }
    return false;
  }
  /* ── slot occupancy helpers ── */
  function isCont(s) { return !!(s && s.cont != null); }        /* double's 2nd link  */
  function isChainEnd(s) { return !!(s && s.chainEnd); }        /* chain's far end     */
  function isPrimary(s) { return !!(s && !isCont(s) && !isChainEnd(s)); } /* the purchasable charm */
  function chWidth(s) { return (s && s.w === 2) ? 2 : 1; }
  function headIndex(idx) {
    var s = state.slots[idx];
    if (!s) return -1;
    if (isCont(s)) return s.cont;
    if (isChainEnd(s)) return s.of;
    return idx;
  }
  function pairFree(i) {          /* two ADJACENT empty links (double) */
    return i >= 0 && i + 1 < state.slots.length && !state.slots[i] && !state.slots[i + 1];
  }
  function chainFree(i) {         /* link i and i+2 empty (middle may hold anything) */
    return i >= 0 && i + 2 < state.slots.length && !state.slots[i] && !state.slots[i + 2];
  }
  function filledSlots() {
    var n = 0;
    state.slots.forEach(function(s) { if (s && !isCont(s)) n += chWidth(s); });
    return n;
  }
  function makeCharm(data, w) {
    return {
      variantId: data.variantId, title: data.title, price: data.price,
      image: data.image, collection: data.collection || '', framePct: data.framePct || 30,
      w: w, isChain: !!data.isChain, isPendant: !!data.isPendant
    };
  }
  function clearAt(idx) {
    var h = headIndex(idx);
    if (h < 0) { if (idx >= 0 && idx < state.slots.length) state.slots[idx] = null; return; }
    var hs = state.slots[h];
    if (hs && hs.chain) {          /* chain: clear head + far end */
      state.slots[h] = null;
      if (hs.mate != null && hs.mate < state.slots.length) state.slots[hs.mate] = null;
      return;
    }
    var w = chWidth(hs);           /* double/single: clear adjacent links */
    for (var k = 0; k < w; k++) { if (h + k < state.slots.length) state.slots[h + k] = null; }
  }
  function fitDoubleAt(prefer) {
    if (pairFree(prefer)) return prefer;
    if (pairFree(prefer - 1)) return prefer - 1;
    for (var i = 0; i < state.slots.length - 1; i++) { if (pairFree(i)) return i; }
    return -1;
  }
  function fitChainAt(prefer) {
    if (chainFree(prefer)) return prefer;
    if (chainFree(prefer - 1)) return prefer - 1;
    if (chainFree(prefer - 2)) return prefer - 2;
    for (var i = 0; i < state.slots.length - 2; i++) { if (chainFree(i)) return i; }
    return -1;
  }

  /* ═══ STATE ═══ */
  var state = {
    base: 'silver',
    baseVariantId: SILVER_VARIANT,
    size: 18,
    slots: [],
    activeCategory: 'all'
  };

  var allCharms = [];
  var colDone = {};            /* collections fully loaded (all pages) */
  var descByProduct = {};      /* body_html kept once per product, not per variant */
  var searchQuery = '';
  var selectedSlot = -1;
  var charmDragging = false;   /* true while a charm is being dragged (desktop) */
  /* ── grid render window ──
     We load the WHOLE catalogue (≈950 products / ≈12k variants) into allCharms so
     tag categories are complete, but only render a growing window of cards so the
     DOM never chokes. More cards append as the grid/page scrolls (infinite scroll,
     no "Load more" button). */
  var filteredCache = [];
  var renderedN = 0;
  var RENDER_STEP = 120;

  function getSlotCount(size) { return parseInt(size) + 2; }

  /* ═══ INIT ═══ */
  function init() {
    state.slots = new Array(getSlotCount(state.size)).fill(null);
    checkDraft();
    initBracelet();
    renderBracelet();
    renderSidebar();
    bindEvents();
    /* Load regular charms first (they lead every grid), then gold, then pendants
       last. The loader runs one collection at a time to avoid Shopify 503s. */
    loadCollection('charms');
    loadCollection('golden-charms');
    loadCollection('pandants-charms');
    /* start centred on the middle of the bracelet (layout must settle first) */
    requestAnimationFrame(function() { centerActiveSlot(false); });
  }

  /* ═══ CANVAS BRACELET RENDERER ═══ */
  var SLOT_W = 56;
  var SLOT_H = 49;
  var bldCanvas, bldCtx, canvasInner;
  var imgCache = {};

  /* request a crisp, consistently-sized image from the Shopify CDN so charms
     stay sharp on the canvas (retina) and in the grid */
  function hiRes(url, w) {
    if (!url || /[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 440);
  }

  /* load & cache an image; returns it when drawable, else null (redraws on load) */
  function getImg(src) {
    var img = imgCache[src];
    if (img) return (img.complete && img.naturalWidth) ? img : null;
    img = new Image();
    img.crossOrigin = 'anonymous'; /* needed for pixel-reads in computeBounds */
    img.onload = function() { renderBracelet(); };
    img.src = src;
    imgCache[src] = img;
    return null;
  }

  /* ── content-bounds detection ──
     Product photos are full shots of the link on a white/light background.
     Find the bounding box of the actual charm so we can crop the background
     away and stretch the photo to exactly replace the blank link. */
  var boundsCache = {};
  var scratchCanvas = document.createElement('canvas');
  var scratchCtx = scratchCanvas.getContext('2d', { willReadFrequently: true });

  function colorDist(r1, g1, b1, r2, g2, b2) {
    return Math.sqrt((r1-r2)*(r1-r2) + (g1-g2)*(g1-g2) + (b1-b2)*(b1-b2));
  }

  function computeBounds(img, src) {
    if (boundsCache[src]) return boundsCache[src];
    var w = img.naturalWidth, h = img.naturalHeight;
    var bounds = { x: 0, y: 0, w: w, h: h };
    try {
      scratchCanvas.width = w; scratchCanvas.height = h;
      scratchCtx.clearRect(0, 0, w, h);
      scratchCtx.drawImage(img, 0, 0);
      var data = scratchCtx.getImageData(0, 0, w, h).data;
      function px(x, y) { var i = (y*w + x)*4; return [data[i], data[i+1], data[i+2], data[i+3]]; }
      /* sample the 4 corners to learn the background colour */
      var corners = [[0,0],[w-1,0],[0,h-1],[w-1,h-1]], br=0, bg=0, bb=0, bc=0;
      corners.forEach(function(c) {
        for (var dx=-2; dx<=2; dx++) for (var dy=-2; dy<=2; dy++) {
          var cx = Math.min(w-1, Math.max(0, c[0]+dx)), cy = Math.min(h-1, Math.max(0, c[1]+dy));
          var p = px(cx, cy); if (p[3] > 10) { br+=p[0]; bg+=p[1]; bb+=p[2]; bc++; }
        }
      });
      var bgR = bc?br/bc:255, bgG = bc?bg/bc:255, bgB = bc?bb/bc:255;
      var minX=w, maxX=0, minY=h, maxY=0, found=false;
      var step = Math.max(1, Math.floor(Math.max(w, h) / 400));
      for (var y=0; y<h; y+=step) for (var x=0; x<w; x+=step) {
        var p = px(x, y);
        if (!(p[3] < 10 || colorDist(p[0], p[1], p[2], bgR, bgG, bgB) < 30)) {
          found = true;
          if (x < minX) minX = x; if (x > maxX) maxX = x;
          if (y < minY) minY = y; if (y > maxY) maxY = y;
        }
      }
      if (found && maxX > minX && maxY > minY) {
        var pad = Math.max(2, Math.round(Math.min(w, h) * 0.01));
        bounds = { x: Math.max(0, minX-pad), y: Math.max(0, minY-pad),
          w: Math.min(w, maxX-minX+pad*2) || 1, h: Math.min(h, maxY-minY+pad*2) || 1 };
      }
      boundsCache[src] = bounds; /* only cache successful reads */
    } catch (e) { /* CORS-tainted canvas → fall back to full image, don't cache */ }
    return bounds;
  }

  /* chain-style products (span 2 links) are excluded from the builder;
     some don't say "chain" in the title, hence the extra patterns */
  function isChainTitle(t) {
    return /chain|double.?link|magnetic.?double/i.test(t || '');
  }

  function isPendantSlot(s) {
    return !!(s && (s.collection === 'pandants-charms' || s.isPendant) && !s.isChain);
  }

  function getSlotFromEvent(e) {
    if (!bldCanvas) return -1;
    var rect = bldCanvas.getBoundingClientRect();
    if (!rect.width) return -1;
    /* scale-safe: map by fraction of rendered width, works under zoom transforms */
    var idx = Math.floor((e.clientX - rect.left) / rect.width * state.slots.length);
    if (idx < 0 || idx >= state.slots.length) return -1;
    return idx;
  }

  function initBracelet() {
    bldCanvas = document.getElementById('bldCanvas');
    if (!bldCanvas) return;
    bldCtx = bldCanvas.getContext('2d');
    bldCtx.imageSmoothingEnabled = true;
    bldCtx.imageSmoothingQuality = 'high';
    canvasInner = bldCanvas.parentElement;

    canvasInner.addEventListener('click', function(e) {
      if (isZoomed()) return;               /* zoom is view-only */
      var idx = getSlotFromEvent(e);
      if (idx < 0) return;
      if (state.slots[idx]) removeCharm(idx);
      else { selectedSlot = idx; centerTarget = idx; renderBracelet(); centerActiveSlot(); }
    });

    canvasInner.addEventListener('dragover', function(e) { if (!isZoomed()) e.preventDefault(); });
    canvasInner.addEventListener('drop', function(e) {
      if (isZoomed()) return;
      e.preventDefault();
      var idx = getSlotFromEvent(e);
      if (idx < 0) return;
      try { placeCharm(idx, JSON.parse(e.dataTransfer.getData('text/plain'))); } catch(err) {}
    });

    /* re-fit / re-center on resize or rotate (re-apply the zoom view if open) */
    window.addEventListener('resize', function() {
      if (fitRaf) cancelAnimationFrame(fitRaf);
      fitRaf = requestAnimationFrame(function() {
        if (isZoomed()) applyZoomView();
        else { fitBracelet(); centerActiveSlot(false); setTrayRows(); }
      });
    });
  }

  /* ── Nomination-style bracelet ──
     The links stay at a readable, tappable size and the strip scrolls
     horizontally (bleeding off both edges) like a real bracelet — we do NOT
     cram the whole thing on screen (that made the links tiny). We keep the
     band tidy by collapsing the empty pendant-dangle reserve when no pendant
     is on the bracelet. centerActiveSlot() glides the working slot into the
     middle after each action so the customer always sees where they're at. */
  var fitRaf = null;
  function fitBracelet() {
    if (!canvasInner) return;
    var wrap = canvasInner.parentElement;               /* .ct-bld-canvas-wrap */
    if (!wrap) return;
    /* never shrink — clear any leftover transform so links stay full size */
    canvasInner.style.transform = '';
    wrap.style.height = '';
    wrap.style.overflow = '';
    wrap.style.textAlign = '';
    var braceletWrap = document.getElementById('bldBraceletWrap');
    if (braceletWrap && braceletWrap.classList.contains('zoomed')) return;
    /* reserve dangle space only when something hangs (pendant or chain) */
    var hasChain = state.slots.some(function(s) { return s && s.image && s.chain; });
    var hasPendant = state.slots.some(function(s) { return s && s.image && isPendantSlot(s); });
    canvasInner.style.paddingBottom = hasChain ? '240px' : (hasPendant ? '' : '24px');
    /* MOBILE: a dangling pendant/chain reserves ~160px which would steal the charm
       grid's height (dropping it to ~2 rows). Flag it so CSS can cap the bracelet
       area and let the dangle scroll instead — keeps the grid at full rows. */
    var cwrap = canvasInner.closest('.ct-bld-canvas-wrap');
    if (cwrap) cwrap.classList.toggle('has-dangle', hasChain || hasPendant);
  }

  /* the slot to keep centred after an action (set by place/remove); -1 = auto */
  var centerTarget = -1;

  /* keep the slot the customer just touched centred — do NOT jump back to the
     start. Priority: explicit centerTarget (just placed/removed) → selected →
     nothing-yet: middle. */
  function centerActiveSlot(smooth) {
    if (!canvasInner) return;
    var wrap = canvasInner.parentElement;
    if (!wrap) return;
    var braceletWrap = document.getElementById('bldBraceletWrap');
    if (braceletWrap && braceletWrap.classList.contains('zoomed')) { centerTarget = -1; return; }
    var n = state.slots.length, idx;
    var hasAny = state.slots.some(function(s) { return !!s; });
    if (centerTarget >= 0 && centerTarget < n) idx = centerTarget;
    else if (selectedSlot >= 0 && selectedSlot < n) idx = selectedSlot;
    else if (!hasAny) idx = Math.floor(n / 2);
    else { centerTarget = -1; return; } /* no specific target — leave scroll where the customer left it */
    centerTarget = -1;
    var target = (idx + 0.5) * SLOT_W - wrap.clientWidth / 2;
    var max = Math.max(0, wrap.scrollWidth - wrap.clientWidth);
    target = Math.max(0, Math.min(target, max));
    try { wrap.scrollTo({ left: target, behavior: smooth === false ? 'auto' : 'smooth' }); }
    catch (e) { wrap.scrollLeft = target; }
  }

  /* ── ZOOM = full-bracelet view (Nomination-style) ──
     Rotate the whole strip 90° and scale it to fit the screen so EVERY link is
     visible at once, top to bottom. View-only (placing is disabled in zoom). */
  function applyZoomView() {
    var braceletWrap = document.getElementById('bldBraceletWrap');
    if (!braceletWrap || !canvasInner) return;
    var wrap = canvasInner.parentElement;
    var hasPendant = state.slots.some(function(s) { return s && s.image && isPendantSlot(s); });
    var thick = hasPendant ? (SLOT_H + 160) : SLOT_H;   /* strip thickness (+ dangle) */
    var length = state.slots.length * SLOT_W;            /* full bracelet length   */
    var de = document.documentElement;
    var vw = window.innerWidth || de.clientWidth || 375;
    var vh = window.innerHeight || de.clientHeight || 640;
    var m = 0.86;
    /* rotated 90°: length runs vertically (fit to height), thickness horizontally */
    var scale = Math.min((vh * m) / length, (vw * m) / thick);
    canvasInner.style.paddingBottom = hasPendant ? '' : '0';
    canvasInner.style.position = 'absolute';
    canvasInner.style.left = '50%';
    canvasInner.style.top = '50%';
    canvasInner.style.transformOrigin = 'center center';
    canvasInner.style.transform = 'translate(-50%,-50%) rotate(90deg) scale(' + scale + ')';
    if (wrap) wrap.style.overflow = 'visible';
  }
  function clearZoomView() {
    if (!canvasInner) return;
    canvasInner.style.position = '';
    canvasInner.style.left = '';
    canvasInner.style.top = '';
    canvasInner.style.transform = '';
    canvasInner.style.transformOrigin = '';
    var wrap = canvasInner.parentElement;
    if (wrap) wrap.style.overflow = '';
  }
  function isZoomed() {
    var bw = document.getElementById('bldBraceletWrap');
    return !!(bw && bw.classList.contains('zoomed'));
  }

  function renderBracelet() {
    if (!bldCanvas || !bldCtx) return;
    var blankSrc = state.base === 'gold' ? BLANK_GOLD : BLANK_SILVER;
    var n = state.slots.length;
    var dpr = window.devicePixelRatio || 1;

    if (bldCanvas.width !== n * SLOT_W * dpr || bldCanvas.height !== SLOT_H * dpr) {
      bldCanvas.width = n * SLOT_W * dpr;
      bldCanvas.height = SLOT_H * dpr;
      bldCanvas.style.width = (n * SLOT_W) + 'px';
      bldCanvas.style.height = SLOT_H + 'px';
    }
    bldCtx.setTransform(dpr, 0, 0, dpr, 0, 0);
    bldCtx.clearRect(0, 0, n * SLOT_W, SLOT_H);

    var blank = getImg(blankSrc);

    for (var i = 0; i < n; i++) {
      var s = state.slots[i];
      if (isCont(s)) continue;          /* second link of a double — drawn by its head */
      var x = i * SLOT_W;
      var w = chWidth(s);               /* 1, or 2 for a double charm */
      var slotPx = w * SLOT_W;
      /* pendant / chain photos bring their own link(s) and are overlaid as <img>,
         so skip the blank underneath them (and skip drawing them on the canvas) */
      var isHang = s && s.image && (isPendantSlot(s) || s.chain);
      var isChainCovered = s && s.chain;          /* chain head link */
      var chainEndCovered = isChainEnd(s);        /* chain far-end link */
      var hangReady = isHang && getImg(s.image);
      if (blank && !hangReady && !chainEndCovered) {
        for (var c = 0; c < w; c++) bldCtx.drawImage(blank, x + c * SLOT_W, 0, SLOT_W, SLOT_H);
      }

      /* normal + double charms draw on the canvas; pendants & chains are overlays */
      if (s && s.image && !isPendantSlot(s) && !s.chain && !isChainEnd(s)) {
        var charm = getImg(s.image);
        if (charm) {
          var b = computeBounds(charm, s.image);
          bldCtx.drawImage(charm, b.x, b.y, b.w, b.h, x, 0, slotPx, SLOT_H);
        }
      }

      if (selectedSlot === i && !s) {
        bldCtx.strokeStyle = CFG.accentColor || '#FF4DA6';
        bldCtx.lineWidth = 2;
        bldCtx.strokeRect(x + 2, 2, SLOT_W - 4, SLOT_H - 4);
      }
    }

    renderPendants();
    renderChains();
    fitBracelet();
  }

  /* Chain charms are ONE photo of the whole piece: two link-bases at the top
     corners joined by a chain with the charm dangling. To keep every chain a
     CONSISTENT size, we scale by the span between the two TOP link-bases (not the
     whole piece — the dangle width varies), so the bases always match the bracelet
     links exactly and only the dangle differs naturally. */
  var chainGeomCache = {};
  function chainGeom(img, src) {
    if (chainGeomCache[src]) return chainGeomCache[src];
    var w = img.naturalWidth, h = img.naturalHeight, geom = null;
    try {
      scratchCanvas.width = w; scratchCanvas.height = h;
      scratchCtx.clearRect(0, 0, w, h); scratchCtx.drawImage(img, 0, 0);
      var data = scratchCtx.getImageData(0, 0, w, h).data;
      function px(x, y) { var i = (y*w + x)*4; return [data[i], data[i+1], data[i+2], data[i+3]]; }
      var cs = [[0,0],[w-1,0],[0,h-1],[w-1,h-1]], br=0,bg=0,bb=0,bc=0;
      cs.forEach(function(c){ for(var dx=-2;dx<=2;dx++)for(var dy=-2;dy<=2;dy++){ var cx=Math.min(w-1,Math.max(0,c[0]+dx)),cy=Math.min(h-1,Math.max(0,c[1]+dy)); var p=px(cx,cy); if(p[3]>10){br+=p[0];bg+=p[1];bb+=p[2];bc++;} } });
      var R=bc?br/bc:255, G=bc?bg/bc:255, B=bc?bb/bc:255;
      function content(x,y){ var p=px(x,y); return !(p[3]<10 || colorDist(p[0],p[1],p[2],R,G,B)<30); }
      var step = Math.max(1, Math.floor(Math.max(w,h)/400));
      var minX=w,maxX=0,minY=h,maxY=0,found=false;
      for(var y=0;y<h;y+=step)for(var x=0;x<w;x+=step){ if(content(x,y)){ found=true; if(x<minX)minX=x; if(x>maxX)maxX=x; if(y<minY)minY=y; if(y>maxY)maxY=y; } }
      if (found && maxX>minX && maxY>minY) {
        /* the two link-bases live in the top band of the content */
        var band = minY + Math.max(2, Math.round((maxY - minY) * 0.20));
        var tMinX = w, tMaxX = 0;
        for(var by=minY;by<=band;by+=step)for(var bx=minX;bx<=maxX;bx+=step){ if(content(bx,by)){ if(bx<tMinX)tMinX=bx; if(bx>tMaxX)tMaxX=bx; } }
        geom = { x: minX, y: minY, topMinX: (tMaxX>tMinX?tMinX:minX), topMaxX: (tMaxX>tMinX?tMaxX:maxX) };
        chainGeomCache[src] = geom;
      }
    } catch (e) { /* CORS-tainted → caller falls back */ }
    return geom;
  }

  function renderChains() {
    if (!canvasInner) return;
    canvasInner.querySelectorAll('.bld-chain').forEach(function(el) { el.remove(); });
    state.slots.forEach(function(s, i) {
      if (!s || !s.chain || !s.image) return;
      var loaded = getImg(s.image);
      if (!loaded) return;
      var span = 3 * SLOT_W;                    /* the two bases span links i..i+2 */
      var g = chainGeom(loaded, s.image), scale, left, top;
      if (g && g.topMaxX > g.topMinX) {
        scale = span / (g.topMaxX - g.topMinX);  /* normalise on the BASE span */
        left = i * SLOT_W - g.topMinX * scale;
        top = -g.y * scale;
      } else {
        var b = computeBounds(loaded, s.image);  /* fallback: full content width */
        scale = span / b.w;
        left = i * SLOT_W - b.x * scale;
        top = -b.y * scale;
      }
      var img = document.createElement('img');
      img.className = 'bld-chain';
      img.alt = ''; img.draggable = false; img.crossOrigin = 'anonymous';
      img.style.width = Math.round(loaded.naturalWidth * scale) + 'px';
      img.style.left = Math.round(left) + 'px';
      img.style.top = Math.round(top) + 'px';
      img.src = s.image;
      canvasInner.appendChild(img);
    });
  }

  /* Pendant photos are shot in a consistent format: the steel connector link
     at the top, the charm dangling below, on a white background. So the photo
     hangs "naturally": we detect the connector's width in the top of the photo
     and scale/position the whole photo so its own link sits exactly on the
     bracelet link, with the charm dangling below at proportional size. */
  var pendantGeomCache = {};

  function pendantGeom(img, src) {
    if (pendantGeomCache[src]) return pendantGeomCache[src];
    var w = img.naturalWidth, h = img.naturalHeight;
    var geom = null;
    try {
      scratchCanvas.width = w; scratchCanvas.height = h;
      scratchCtx.clearRect(0, 0, w, h);
      scratchCtx.drawImage(img, 0, 0);
      var data = scratchCtx.getImageData(0, 0, w, h).data;
      function px(x, y) { var i = (y*w + x)*4; return [data[i], data[i+1], data[i+2], data[i+3]]; }
      var corners = [[0,0],[w-1,0],[0,h-1],[w-1,h-1]], br=0, bg=0, bb=0, bc=0;
      corners.forEach(function(c) {
        for (var dx=-2; dx<=2; dx++) for (var dy=-2; dy<=2; dy++) {
          var cx = Math.min(w-1, Math.max(0, c[0]+dx)), cy = Math.min(h-1, Math.max(0, c[1]+dy));
          var p = px(cx, cy); if (p[3] > 10) { br+=p[0]; bg+=p[1]; bb+=p[2]; bc++; }
        }
      });
      var bgR = bc?br/bc:255, bgG = bc?bg/bc:255, bgB = bc?bb/bc:255;
      function isContent(x, y) {
        var p = px(x, y);
        return !(p[3] < 10 || colorDist(p[0], p[1], p[2], bgR, bgG, bgB) < 30);
      }
      var minX=w, maxX=0, minY=h, maxY=0, found=false;
      var step = Math.max(1, Math.floor(Math.max(w, h) / 400));
      for (var y=0; y<h; y+=step) for (var x=0; x<w; x+=step) {
        if (isContent(x, y)) {
          found = true;
          if (x < minX) minX = x; if (x > maxX) maxX = x;
          if (y < minY) minY = y; if (y > maxY) maxY = y;
        }
      }
      if (found && maxX > minX && maxY > minY) {
        /* connector = widest content span in the top 15% of the content */
        var frameBottom = minY + Math.max(2, Math.round((maxY - minY) * 0.15));
        var fMinX = w, fMaxX = 0;
        for (var fy = minY; fy <= frameBottom; fy += step) {
          for (var fx = minX; fx <= maxX; fx += step) {
            if (isContent(fx, fy)) {
              if (fx < fMinX) fMinX = fx;
              if (fx > fMaxX) fMaxX = fx;
            }
          }
        }
        geom = {
          x: minX, y: minY, w: maxX - minX, h: maxY - minY,
          frameW: fMaxX > fMinX ? fMaxX - fMinX : 0,
          frameCX: fMaxX > fMinX ? (fMinX + fMaxX) / 2 : (minX + maxX) / 2
        };
        pendantGeomCache[src] = geom;
      }
    } catch (e) { /* CORS-tainted → fallback styling, don't cache */ }
    return geom;
  }

  function applyPendantGeom(el, loaded, src, i) {
    var g = pendantGeom(loaded, src);
    if (!g) g = { x: 0, y: 0, w: loaded.naturalWidth, h: loaded.naturalHeight,
                  frameW: 0, frameCX: loaded.naturalWidth / 2 };
    /* sane connector → its width fills the slot; otherwise fit content width */
    var scale = (g.frameW > loaded.naturalWidth * 0.1 && g.frameW <= g.w)
      ? SLOT_W / g.frameW
      : SLOT_W / g.w;
    /* keep the dangle inside the reserved space below the strip */
    if (g.h * scale > 150) scale = 150 / g.h;
    el.style.width = Math.round(loaded.naturalWidth * scale) + 'px';
    el.style.left  = Math.round(i * SLOT_W + SLOT_W / 2 - g.frameCX * scale) + 'px';
    el.style.top   = Math.round(-g.y * scale) + 'px';
  }

  function renderPendants() {
    if (!canvasInner) return;
    canvasInner.querySelectorAll('.bld-pendant').forEach(function(el) { el.remove(); });
    state.slots.forEach(function(s, i) {
      if (!isPendantSlot(s) || !s.image) return;
      var loaded = getImg(s.image); /* re-renders (incl. pendants) once loaded */
      if (!loaded) return;
      var img = document.createElement('img');
      img.className = 'bld-pendant';
      img.alt = '';
      img.draggable = false;
      applyPendantGeom(img, loaded, s.image, i);
      img.src = s.image;
      canvasInner.appendChild(img);
    });
  }

  /* ═══ CHARM LOADING ═══
     Load ENTIRE collections (all pages) so tag categories are complete. Shopify
     rate-limits rapid products.json calls (503s), so we load ONE collection at a
     time through a queue, with retry+backoff on failure. At limit=250 each
     collection is only 1–2 requests. */
  var LOAD_LIMIT = 250;
  var loadQueue = [], colQueued = {}, loadingNow = false;

  function loadCollection(collection) {           /* enqueue (idempotent) */
    if (colDone[collection] || colQueued[collection]) return;
    colQueued[collection] = true;
    loadQueue.push(collection);
    runQueue();
  }

  function runQueue() {
    if (loadingNow) return;
    var collection = loadQueue.shift();
    if (!collection) {
      var le = document.getElementById('bldLoading');
      if (le) le.style.display = 'none';
      return;
    }
    loadingNow = true;
    loadColPages(collection, function() { loadingNow = false; runQueue(); });
  }

  function loadColPages(collection, done) {
    var loadEl = document.getElementById('bldLoading');
    if (loadEl && !allCharms.length) loadEl.style.display = 'block';
    var page = 1;
    function fetchPage(attempt) {
      fetch('/collections/' + collection + '/products.json?limit=' + LOAD_LIMIT + '&page=' + page)
        .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function(data) {
          var products = data.products || [];
          processCharms(products, collection);
          if (products.length === LOAD_LIMIT) {
            page++;
            setTimeout(function() { fetchPage(0); }, 250);   /* gentle spacing */
          } else {
            colDone[collection] = true;
            done();
          }
        })
        .catch(function() {
          /* 503 / network hiccup → back off and retry the SAME page (up to 6×) */
          if (attempt < 6) setTimeout(function() { fetchPage(attempt + 1); }, 600 * (attempt + 1));
          else done();   /* give up this collection, let the queue continue */
        });
    }
    fetchPage(0);
  }

  function processCharms(products, collection) {
    products.forEach(function(p) {
      if (!p.variants) return;
      if (isChainTitle(p.title)) return;   /* chains hidden for now (rendering unresolved) */
      var pImg = (p.images && p.images.length) ? p.images[0] : null;
      if (pImg && typeof pImg === 'object' && pImg.src) pImg = pImg.src;
      var pTags = (p.tags || []).map(function(t) { return t.toLowerCase(); });
      var pChain = isChainTitle(p.title);                 /* chain wins over double */
      var pDouble = !pChain && isDoubleProduct(p.title, pTags);
      /* pendant if it's in the pendants collection OR flagged by keyword/tag */
      var pPendant = !pChain && (collection === 'pandants-charms' || isPendantProduct(p.title, pTags));
      /* keep the description ONCE per product (not copied onto every variant) */
      if (!(p.id in descByProduct)) descByProduct[p.id] = p.body_html || p.description || '';
      p.variants.forEach(function(v) {
        var img = null;
        if (v.featured_image) {
          img = typeof v.featured_image === 'string' ? v.featured_image : v.featured_image.src;
        }
        /* pendants must have their own variant image — product grid images break frame detection */
        if (!img && collection === 'pandants-charms') return;
        if (!img) img = pImg;
        if (!img) return;
        var exists = allCharms.find(function(c) { return c.variantId == v.id; });
        if (exists) {
          /* Same charm already loaded (usually from the 'charms' collection via a
             themed category). If we now know it's a pendant, upgrade the existing
             card so it hangs everywhere — and, when this copy comes from the
             pendants collection, adopt its proper (connector-at-top) photo. */
          if (pPendant && !exists.isPendant) {
            exists.isPendant = true;
            if (collection === 'pandants-charms') {
              exists.collection = 'pandants-charms';
              exists.image = hiRes(img, 440);
            }
          }
          return;
        }
        var framePct = 30; /* default frame % */
        (p.tags || []).forEach(function(t) {
          var m = t.match(/^frame-pct-(\d+)$/i);
          if (m) framePct = parseInt(m[1]);
        });
        allCharms.push({
          variantId: v.id,
          productId: p.id,
          handle: p.handle,
          title: v.title || p.title,
          productTitle: p.title,
          price: Math.round(parseFloat(v.price) * 100),
          image: hiRes(img, 440),
          framePct: framePct,
          tags: pTags,
          collection: collection,
          isDouble: pDouble,
          isChain: pChain,
          isPendant: pPendant
        });
      });
    });
    regrid();
  }

  /* Called after a background page of data lands. If nothing is rendered yet,
     do a full render; otherwise the catalogue just grew at the end — leave the
     current cards in place (so scrolling isn't disturbed) and let more append on
     scroll. */
  function regrid() {
    if (renderedN === 0) { renderGrid(); return; }
    filteredCache = filterCharms();
    updateMoreHint();
  }

  /* ═══ GRID RENDERING ═══
     Full (re)render: reset the window and paint the first batch. Used on category
     change, search, or the first data load. */
  function renderGrid() {
    var grid = document.getElementById('bldGrid');
    var title = document.getElementById('bldGridTitle');
    var cat = getCat(state.activeCategory);
    title.textContent = (state.activeCategory === 'all' || !cat) ? 'ALL CHARMS' : (cat.label || '').toUpperCase();

    filteredCache = filterCharms();
    renderedN = 0;
    grid.innerHTML = '';
    if (!filteredCache.length) {
      document.getElementById('bldLoading').style.display = 'none';
      grid.innerHTML = '<div class="ct-bld-empty-grid">No charms found in this category.</div>';
      updateMoreHint();
      return;
    }
    appendMore();
  }

  /* Append the next window of cards (does not touch already-rendered cards, so
     scroll position is preserved). */
  function appendMore() {
    if (renderedN >= filteredCache.length) { updateMoreHint(); return; }
    var grid = document.getElementById('bldGrid');
    if (!grid) return;
    var usedIds = {};
    state.slots.forEach(function(s) { if (s && s.variantId) usedIds[s.variantId] = true; });

    var end = Math.min(filteredCache.length, renderedN + RENDER_STEP);
    var html = '';
    for (var i = renderedN; i < end; i++) {
      var charm = filteredCache[i];
      var inUse = usedIds[charm.variantId] ? ' in-bracelet' : '';
      var dblCls = charm.isDouble ? ' is-double' : '';
      var priceStr = money(charm.price);
      var charmData = JSON.stringify({
        variantId: charm.variantId, title: charm.title, price: charm.price, image: charm.image, collection: charm.collection, framePct: charm.framePct, isDouble: charm.isDouble, isChain: charm.isChain, isPendant: charm.isPendant
      });
      html += '<div class="ct-bld-charm' + inUse + dblCls + '" draggable="true" data-charm="' + charmData.replace(/"/g, '&quot;') + '">' +
        /* crossorigin so the bracelet canvas reuses THIS cached image instead of
           re-downloading a separate CORS copy on drop (was the desktop delay) */
        '<img src="' + charm.image + '" alt="" loading="lazy" crossorigin="anonymous">' +
        '<button class="ct-bld-info-btn" type="button" data-info="' + charm.variantId + '" aria-label="Charm details">i</button>' +
        '<div class="ct-bld-charm-tooltip">' + (charm.title||'').replace(/</g,'&lt;') + ' · ' + priceStr + '</div>' +
        '</div>';
    }
    grid.insertAdjacentHTML('beforeend', html);
    renderedN = end;
    bindCharmEvents();   /* binds only the newly-added (unbound) cards */
    setTrayRows();
    updateMoreHint();
  }

  /* toggle the mobile "more to the right" cue while cards remain (rendered or not) */
  function updateMoreHint() {
    var grid = document.getElementById('bldGrid');
    var wrap = document.getElementById('bldGridWrap');
    if (!grid || !wrap) return;
    var remaining = grid.scrollWidth - grid.clientWidth - grid.scrollLeft;
    wrap.classList.toggle('ct-has-more', remaining > 24 || renderedN < filteredCache.length);
  }

  /* infinite scroll: append more cards as the grid (mobile, horizontal) or the
     grid-wrap (desktop, vertical) nears its end */
  function onGridScroll(el, horizontal) {
    if (!el || renderedN >= filteredCache.length) return;
    var nearEnd = horizontal
      ? (el.scrollLeft + el.clientWidth >= el.scrollWidth - 600)
      : (el.scrollTop + el.clientHeight >= el.scrollHeight - 600);
    if (nearEnd) appendMore();
  }

  /* MOBILE only: keep charms a FIXED size (62px) and fit as many whole rows as
     the space allows (up to 5). When a pendant/chain reserves dangle space the
     grid area shrinks, so we drop to fewer rows instead of shrinking or clipping
     the charms. Desktop keeps its normal vertical-scroll grid. */
  function setTrayRows() {
    /* Rows are now FIXED in CSS (mobile = 4 rows; the page scrolls to reach them).
       We no longer recompute rows from available height — that recompute was what
       reflowed the tray to fewer rows when a pendant grew the bracelet. Just clear
       any stale inline override so the CSS row count wins. */
    var grid = document.getElementById('bldGrid');
    if (grid) grid.style.gridTemplateRows = '';
  }

  function filterCharms() {
    var q = searchQuery.toLowerCase().trim();
    if (q) {
      return allCharms.filter(function(c) {
        return (((c.title || '') + ' ' + (c.productTitle || '')).toLowerCase()).indexOf(q) > -1;
      });
    }

    /* "All" = regular charms only. Pendants (dangles) have their own category, so
       they're kept out of All to avoid duplicating them / leading with dangles. */
    if (state.activeCategory === 'all') {
      return allCharms.filter(function(c) { return !c.isPendant; });
    }

    var cat = getCat(state.activeCategory);
    if (!cat) return allCharms.filter(function(c) { return !c.isPendant; });

    var matched = allCharms.filter(function(c) {
      if (!inScope(c, cat.scope)) return false;
      var titleLow = ((c.productTitle || '') + ' ' + (c.title || '')).toLowerCase();
      /* exclusions win — keeps groups clean of false positives */
      for (var e = 0; e < cat.exclude.length; e++) {
        if (titleLow.indexOf(cat.exclude[e]) > -1) return false;
      }
      /* no keywords/tags set → show the whole scope pool (e.g. "Pendants", "Gold") */
      if (!cat.keywords.length && !cat.tags.length) return true;
      for (var t = 0; t < cat.tags.length; t++) {
        if (c.tags.indexOf(cat.tags[t]) > -1) return true;
      }
      for (var k = 0; k < cat.keywords.length; k++) {
        if (hasWord(titleLow, cat.keywords[k])) return true;
      }
      return false;
    });
    /* lead with regular charms; dangling pendants sort to the end (stable) */
    return matched.sort(function(a, b) { return (a.isPendant ? 1 : 0) - (b.isPendant ? 1 : 0); });
  }

  function bindCharmEvents() {
    document.querySelectorAll('#bldGrid .ct-bld-charm:not([data-bound])').forEach(function(el) {
      el.dataset.bound = '1';   /* so re-runs (from appendMore) skip existing cards */
      var infoBtn = el.querySelector('.ct-bld-info-btn');
      if (infoBtn) {
        infoBtn.addEventListener('click', function(e) { e.stopPropagation(); openInfo(infoBtn.dataset.info); });
        infoBtn.addEventListener('mousedown', function(e) { e.stopPropagation(); });
        infoBtn.addEventListener('dragstart', function(e) { e.preventDefault(); e.stopPropagation(); });
      }
      /* desktop mouse drag-and-drop */
      el.addEventListener('dragstart', function(e) {
        e.dataTransfer.setData('text/plain', el.dataset.charm);
        e.dataTransfer.effectAllowed = 'move';
        charmDragging = true;   /* enables edge auto-scroll so you can reach the bracelet */
      });
      el.addEventListener('dragend', function() { charmDragging = false; });

      /* ── mobile: HOLD-then-DRAG ──
         A quick swipe still scrolls the tray/page; press & hold (~200ms) picks
         the charm up, then drag it onto any slot. (Immediate drag can't coexist
         with the swipe-to-scroll tray, so we gate it behind a short hold.) */
      var lpTimer = null, ghost = null, sx = 0, sy = 0, armed = false, suppressClick = false;

      el.addEventListener('click', function() {
        if (suppressClick) { suppressClick = false; return; }  /* just dragged — don't also add */
        addCharmToNext(JSON.parse(el.dataset.charm));
      });

      el.addEventListener('touchstart', function(e) {
        if (e.touches.length > 1) return;
        var t = e.touches[0]; sx = t.clientX; sy = t.clientY; armed = false;
        if (lpTimer) clearTimeout(lpTimer);
        lpTimer = setTimeout(function() {
          armed = true;
          var data = JSON.parse(el.dataset.charm);
          ghost = document.createElement('div');
          ghost.className = 'ct-bld-ghost';
          ghost.innerHTML = '<img src="' + data.image + '" crossorigin="anonymous">';
          ghost.style.left = (sx - 28) + 'px';
          ghost.style.top = (sy - 28) + 'px';
          ghost._data = data;
          document.body.appendChild(ghost);
          if (navigator.vibrate) { try { navigator.vibrate(15); } catch (err) {} }
        }, 120);   /* shorter hold = easier to pick up & drag */
      }, { passive: true });

      el.addEventListener('touchmove', function(e) {
        var t = e.touches[0];
        if (!armed) {
          /* moved before the hold fired → it's a scroll: cancel the pickup */
          if (Math.abs(t.clientX - sx) > 8 || Math.abs(t.clientY - sy) > 8) {
            if (lpTimer) { clearTimeout(lpTimer); lpTimer = null; }
          }
          return; /* let the tray / page scroll */
        }
        e.preventDefault(); /* dragging now — don't scroll */
        ghost.style.left = (t.clientX - 28) + 'px';
        ghost.style.top = (t.clientY - 28) + 'px';
      }, { passive: false });

      el.addEventListener('touchend', function(e) {
        if (lpTimer) { clearTimeout(lpTimer); lpTimer = null; }
        if (!armed) return; /* was a tap → click handler adds it */
        var t = e.changedTouches[0];
        /* forgiving drop: release anywhere over the bracelet's horizontal span
           (with generous vertical slack) and it snaps to the nearest link */
        if (bldCanvas) {
          var r = bldCanvas.getBoundingClientRect();
          var idx = getSlotFromEvent({ clientX: t.clientX, clientY: t.clientY });
          if (idx >= 0 && idx < state.slots.length && t.clientY >= r.top - 90 && t.clientY <= r.bottom + 90) {
            placeCharm(idx, ghost._data);
          }
        }
        if (ghost) { ghost.remove(); ghost = null; }
        armed = false;
        suppressClick = true;
        setTimeout(function() { suppressClick = false; }, 400);
      }, { passive: true });

      el.addEventListener('touchcancel', function() {
        if (lpTimer) { clearTimeout(lpTimer); lpTimer = null; }
        if (ghost) { ghost.remove(); ghost = null; }
        armed = false;
      }, { passive: true });
    });
  }

  /* ═══ CHARM PLACEMENT ═══ */
  /* place into the first empty slot AT/AFTER what the customer is currently
     looking at (view centre) — then wrap backwards — so tapping a charm adds it
     where they're working instead of jumping to the far-left start */
  function addCharmToNext(data) {
    var n = state.slots.length;
    var wrap = canvasInner && canvasInner.parentElement;
    var start = 0;
    if (wrap && wrap.clientWidth) start = Math.floor((wrap.scrollLeft + wrap.clientWidth / 2) / SLOT_W);
    start = Math.max(0, Math.min(n - 1, start));

    if (data.isChain) {
      /* need link i and link i+2 free (one usable link between) */
      var ch = -1;
      if (selectedSlot >= 0 && chainFree(selectedSlot)) ch = selectedSlot;
      if (ch < 0) for (var cp = start; cp < n - 2; cp++) { if (chainFree(cp)) { ch = cp; break; } }
      if (ch < 0) for (var cq = Math.min(start, n - 3); cq >= 0; cq--) { if (chainFree(cq)) { ch = cq; break; } }
      if (ch < 0) return; /* no room for a chain */
      selectedSlot = -1;
      placeCharm(ch, data);
      return;
    }

    if (data.isDouble) {
      /* need two consecutive empty links */
      var head = -1;
      if (selectedSlot >= 0 && pairFree(selectedSlot)) head = selectedSlot;
      if (head < 0) for (var p = start; p < n - 1; p++) { if (pairFree(p)) { head = p; break; } }
      if (head < 0) for (var q = Math.min(start, n - 2); q >= 0; q--) { if (pairFree(q)) { head = q; break; } }
      if (head < 0) return; /* no room for a double */
      selectedSlot = -1;
      placeCharm(head, data);
      return;
    }

    var idx = -1;
    if (selectedSlot >= 0 && selectedSlot < n && !state.slots[selectedSlot]) idx = selectedSlot;
    else {
      for (var i = start; i < n; i++) { if (!state.slots[i]) { idx = i; break; } }
      if (idx < 0) for (var j = start - 1; j >= 0; j--) { if (!state.slots[j]) { idx = j; break; } }
    }
    if (idx < 0) return; /* bracelet full */
    selectedSlot = -1;
    placeCharm(idx, data);
  }

  function placeCharm(idx, data) {
    var n = state.slots.length;
    if (idx < 0 || idx >= n) return;
    if (data.isChain) {
      var ch = fitChainAt(idx);
      if (ch < 0) return;                 /* no room for a chain (needs link i & i+2) */
      var chHead = makeCharm(data, 1); chHead.chain = true; chHead.mate = ch + 2;
      var chEnd = makeCharm(data, 1); chEnd.chainEnd = true; chEnd.of = ch;
      state.slots[ch] = chHead;
      state.slots[ch + 2] = chEnd;
      centerTarget = ch + 1;              /* centre on the middle of the chain */
    } else if (data.isDouble) {
      var head = fitDoubleAt(idx);
      if (head < 0) return;               /* no room for a 2-link charm */
      state.slots[head] = makeCharm(data, 2);
      state.slots[head + 1] = { cont: head };
      centerTarget = head;
    } else {
      clearAt(idx);                       /* dropping onto an existing charm replaces it */
      state.slots[idx] = makeCharm(data, 1);
      centerTarget = idx;
    }
    selectedSlot = -1;
    update();
  }

  function removeCharm(idx) {
    var h = headIndex(idx);
    centerTarget = h >= 0 ? h : idx;
    clearAt(idx);                         /* clears a double's both links */
    update();
  }

  /* ═══ CHARM INFO POPUP (option A) ═══ */
  var infoWired = false;
  function openInfo(variantId) {
    var c = allCharms.find(function(x) { return String(x.variantId) === String(variantId); });
    if (!c) return;
    var modal = document.getElementById('bldInfoModal');
    if (!modal) return;
    if (!infoWired) wireInfoModal();
    document.getElementById('bldInfoImg').src = c.image;
    document.getElementById('bldInfoTitle').textContent = c.productTitle || c.title || 'Charm';
    var vEl = document.getElementById('bldInfoVariant');
    vEl.textContent = (c.title && c.productTitle && c.title !== c.productTitle) ? c.title : '';
    vEl.style.display = vEl.textContent ? '' : 'none';
    document.getElementById('bldInfoPrice').textContent = money(c.price);
    /* short plain-text excerpt only — full details live on the product page */
    var tmp = document.createElement('div');
    tmp.innerHTML = descByProduct[c.productId] || '';
    var txt = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
    if (txt.length > 180) txt = txt.slice(0, 180).replace(/\s+\S*$/, '') + '…';
    document.getElementById('bldInfoDesc').textContent =
      txt || 'A little charm with a lot of personality. Click on and off any time — no tools needed.';
    document.getElementById('bldInfoLink').href = '/products/' + c.handle;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeInfo() {
    var m = document.getElementById('bldInfoModal');
    if (m) m.hidden = true;
    document.body.style.overflow = '';
  }
  function wireInfoModal() {
    infoWired = true;
    var close = document.getElementById('bldInfoClose');
    var overlay = document.getElementById('bldInfoOverlay');
    if (close) close.addEventListener('click', closeInfo);
    if (overlay) overlay.addEventListener('click', closeInfo);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeInfo(); });
  }

  function update() {
    renderBracelet();
    renderSidebar();
    refreshGridUsed();   /* light: just toggle the "in-bracelet" state, don't rebuild the whole grid */
    centerActiveSlot();
    requestAnimationFrame(setTrayRows);  /* pendant may have changed the grid height → refit rows */
    saveDraft();
  }

  /* update which grid cards show as "in bracelet" WITHOUT rebuilding/re-binding
     the whole grid — rebuilding on every add was slow on desktop and destroyed
     the card mid-drag (breaking drag-and-drop) */
  function refreshGridUsed() {
    var grid = document.getElementById('bldGrid');
    if (!grid) return;
    var usedIds = {};
    state.slots.forEach(function(s) { if (s && s.variantId) usedIds[s.variantId] = true; });
    grid.querySelectorAll('.ct-bld-charm').forEach(function(el) {
      var id;
      try { id = JSON.parse(el.dataset.charm).variantId; } catch (e) { return; }
      el.classList.toggle('in-bracelet', !!usedIds[id]);
    });
  }

  /* ═══ SIDEBAR ═══ */
  function renderSidebar() {
    var charmCount = 0, charmTotal = 0;
    state.slots.forEach(function(s) { if (isPrimary(s)) { charmCount++; charmTotal += s.price; } });

    var slotCount = state.slots.length;
    var used = filledSlots();          /* links occupied (a double = 2) */
    var TOP = DISC_TIERS[DISC_TIERS.length - 1];
    var discPct = 0, nextTier = null;
    for (var ti = 0; ti < DISC_TIERS.length; ti++) {
      if (charmCount >= DISC_TIERS[ti].min) discPct = DISC_TIERS[ti].pct;
      else if (!nextTier) nextTier = DISC_TIERS[ti];
    }

    var discount = Math.round(charmTotal * discPct / 100);
    var total = BASE_PRICE + charmTotal - discount;

    // Total
    document.getElementById('bldTotal').textContent = money(total);
    document.getElementById('bldMobileTotal').textContent = money(total);
    document.getElementById('bldMobileCount').textContent = charmCount + ' charm' + (charmCount !== 1 ? 's' : '');

    // Base item
    document.getElementById('bldBaseName').textContent = (state.base === 'gold' ? 'Gold' : 'Silver') + ' Bracelet';
    document.getElementById('bldBasePrice').textContent = money(BASE_PRICE);
    var baseIcon = document.getElementById('bldBaseIcon');
    baseIcon.className = 'ct-bld-base-icon' + (state.base === 'gold' ? ' gold-icon' : '');

    // Discount
    var fillPct = Math.min(100, charmCount / TOP.min * 100);

    document.getElementById('bldDiscFill').style.width = fillPct + '%';
    var _fm = document.getElementById('bldDiscFillM'); if (_fm) _fm.style.width = fillPct + '%';

    var discMsg = document.getElementById('bldDiscMsg');
    var discSave = document.getElementById('bldDiscSave');
    var mobileSave = document.getElementById('bldMobileSave');

    var msgHTML;
    if (discPct > 0) {
      var climb = nextTier ? ' — add <span class="accent">' + (nextTier.min - charmCount) + ' more</span> for ' + nextTier.pct + '%!' : '';
      msgHTML = 'You unlocked <span class="accent">' + discPct + '% off</span>!' + climb;
      discSave.style.display = 'flex';
      discSave.textContent = 'You save $' + (discount / 100).toFixed(2);
      mobileSave.textContent = 'Save $' + (discount / 100).toFixed(2);
    } else {
      var next = DISC_TIERS[0].min - charmCount;
      msgHTML = 'Add <span class="accent">' + next + ' more charm' + (next !== 1 ? 's' : '') + '</span> to unlock ' + DISC_TIERS[0].pct + '% off!';
      discSave.style.display = 'none';
      mobileSave.textContent = '';
    }
    discMsg.innerHTML = msgHTML;
    var _mm = document.getElementById('bldDiscMsgM'); if (_mm) _mm.innerHTML = msgHTML;

    // Markers
    document.querySelectorAll('.ct-bld-disc-marker').forEach(function(m) {
      var at = m.dataset.at;
      if (at === 'full') m.classList.toggle('reached', used >= slotCount);
      else m.classList.toggle('reached', charmCount >= parseInt(at));
    });

    // Item list
    var listEl = document.getElementById('bldItemList');
    var emptyEl = document.getElementById('bldItemsEmpty');
    var html = '';
    state.slots.forEach(function(s, i) {
      if (!isPrimary(s)) return;        /* skip empty, double 2nd link, chain far end */
      var priceStr = money(s.price);
      if (discPct > 0) {
        var discounted = s.price - Math.round(s.price * discPct / 100);
        priceStr = '<span style="text-decoration:line-through;color:#b0a8b0;font-size:11px;">' + money(s.price) + '</span> ' + money(discounted);
      }
      var slotLabel = s.chain ? ('Links ' + (i+1) + ' & ' + (i+3))
                    : (chWidth(s) === 2 ? ('Slots ' + (i+1) + '–' + (i+2)) : ('Slot ' + (i+1)));
      html += '<div class="ct-bld-item">' +
        '<div class="ct-bld-item-img"><img src="' + s.image + '" alt=""></div>' +
        '<div class="ct-bld-item-info"><div class="ct-bld-item-name">' + s.title + '</div>' +
        '<div class="ct-bld-item-slot">' + slotLabel + ' of ' + state.slots.length + '</div></div>' +
        '<div class="ct-bld-item-price">' + priceStr + '</div>' +
        '<button class="ct-bld-item-remove" data-rm="' + i + '">&times;</button></div>';
    });
    listEl.innerHTML = html;
    emptyEl.style.display = charmCount === 0 ? 'block' : 'none';

    listEl.querySelectorAll('.ct-bld-item-remove').forEach(function(btn) {
      btn.addEventListener('click', function() { removeCharm(parseInt(btn.dataset.rm)); });
    });

    // Mobile panel — lead with the base bracelet line (same as desktop) so the
    // total makes sense: customers were seeing e.g. "3 charms" but a $50 total
    // and couldn't tell the extra $20 was the bracelet itself.
    var mBaseName = (state.base === 'gold' ? 'Gold' : 'Silver') + ' Bracelet';
    var mBaseIcon = 'ct-bld-base-icon' + (state.base === 'gold' ? ' gold-icon' : '');
    var mBaseHTML = '<div class="ct-bld-base-item">' +
      '<div class="' + mBaseIcon + '"></div>' +
      '<div class="ct-bld-item-info"><div class="ct-bld-item-name">' + mBaseName + '</div>' +
      '<div class="ct-bld-item-slot">Base bracelet</div></div>' +
      '<div class="ct-bld-item-price">' + money(BASE_PRICE) + '</div></div>';
    var panelInner = document.getElementById('bldMobilePanelInner');
    if (panelInner) panelInner.innerHTML = mBaseHTML + (html || '<div class="ct-bld-items-empty">Start adding charms!</div>');
    if (panelInner) {
      panelInner.querySelectorAll('.ct-bld-item-remove').forEach(function(btn) {
        btn.addEventListener('click', function() { removeCharm(parseInt(btn.dataset.rm)); });
      });
    }
  }

  /* ═══ EVENTS ═══ */
  function bindEvents() {
    // Color buttons
    document.querySelectorAll('.ct-bld-color-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.ct-bld-color-btn').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state.base = btn.dataset.base;
        state.baseVariantId = btn.dataset.variant;
        update();
      });
    });

    // Size
    document.getElementById('bldSize').addEventListener('change', function() {
      var newSize = parseInt(this.value);
      var newCount = getSlotCount(newSize);
      var oldSlots = state.slots.slice();
      state.size = newSize;
      state.slots = new Array(newCount).fill(null);
      for (var i = 0; i < Math.min(oldSlots.length, newCount); i++) {
        state.slots[i] = oldSlots[i];
      }
      /* if the new size cut a double/chain apart, drop the orphaned link */
      var len = state.slots.length;
      for (var k = 0; k < len; k++) {
        var sc = state.slots[k];
        if (!sc) continue;
        if (isCont(sc)) { if (sc.cont >= len || !state.slots[sc.cont]) state.slots[k] = null; continue; }
        if (isChainEnd(sc)) { if (sc.of < 0 || !state.slots[sc.of] || !state.slots[sc.of].chain) state.slots[k] = null; continue; }
        if (sc.chain) { if (sc.mate >= len || !isChainEnd(state.slots[sc.mate])) state.slots[k] = null; continue; }
        if (chWidth(sc) === 2 && (k + 1 >= len || !isCont(state.slots[k + 1]))) state.slots[k] = null;
      }
      update();
    });

    // Category buttons
    document.querySelectorAll('.ct-bld-cat-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.ct-bld-cat-btn').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state.activeCategory = btn.dataset.cat;
        searchQuery = '';
        document.getElementById('bldSearchInput').value = '';

        /* make sure the collection this category needs is loaded (idempotent) */
        loadCollection(catCollection(getCat(state.activeCategory)));
        renderGrid();
      });
    });

    // Search
    document.getElementById('bldSearchOpen').addEventListener('click', function() {
      document.getElementById('bldSearchOverlay').classList.add('open');
      document.getElementById('bldSearchInput').focus();
    });
    document.getElementById('bldSearchClose').addEventListener('click', function() {
      document.getElementById('bldSearchOverlay').classList.remove('open');
      searchQuery = '';
      document.getElementById('bldSearchInput').value = '';
      renderGrid();
    });
    document.getElementById('bldSearchInput').addEventListener('input', function() {
      searchQuery = this.value;
      renderGrid();
    });

    /* ── Category row: make it obvious there are more categories to the side ──
       Shows edge fades + arrow buttons only on the side that has hidden tabs, and
       plays a one-time nudge so first-time visitors realise the row scrolls. */
    var catsEl = document.getElementById('bldCats');
    var catScroller = document.getElementById('bldCatsScroller');
    function updateCatNav() {
      if (!catsEl || !catScroller) return;
      var max = catsEl.scrollWidth - catsEl.clientWidth;
      catScroller.classList.toggle('can-left', catsEl.scrollLeft > 4);
      catScroller.classList.toggle('can-right', catsEl.scrollLeft < max - 4);
    }
    function scrollCats(dir) {
      if (!catsEl) return;
      catsEl.scrollBy({ left: dir * Math.max(150, catsEl.clientWidth * 0.7), behavior: 'smooth' });
    }
    if (catsEl && catScroller) {
      catsEl.addEventListener('scroll', updateCatNav, { passive: true });
      window.addEventListener('resize', updateCatNav);
      var prevBtn = document.getElementById('bldCatsPrev');
      var nextBtn = document.getElementById('bldCatsNext');
      if (prevBtn) prevBtn.addEventListener('click', function() { scrollCats(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { scrollCats(1); });
      updateCatNav();
    }
    function nudgeCats() {
      if (!catsEl || !catScroller) return;
      updateCatNav();
      var max = catsEl.scrollWidth - catsEl.clientWidth;
      if (max < 24) return;                                  // everything already fits
      if (localStorage.getItem('ct-builder-cats-hinted')) return;
      localStorage.setItem('ct-builder-cats-hinted', '1');
      var nextBtn = document.getElementById('bldCatsNext');
      if (nextBtn) { nextBtn.classList.remove('pulse'); void nextBtn.offsetWidth; nextBtn.classList.add('pulse'); }
      catsEl.scrollTo({ left: 60, behavior: 'smooth' });
      setTimeout(function() { catsEl.scrollTo({ left: 0, behavior: 'smooth' }); }, 650);
    }

    // Infinite scroll — append more cards as you reach the end. Mobile scrolls the
    // grid horizontally; desktop scrolls the grid-wrap vertically. No button.
    var gridEl = document.getElementById('bldGrid');
    var wrapEl = document.getElementById('bldGridWrap');
    if (gridEl) gridEl.addEventListener('scroll', function() { updateMoreHint(); onGridScroll(gridEl, true); }, { passive: true });
    if (wrapEl) wrapEl.addEventListener('scroll', function() { onGridScroll(wrapEl, false); }, { passive: true });

    /* auto-scroll the page while dragging a charm near the top/bottom edge, so
       you can reach the bracelet even if it's scrolled off-screen (desktop) */
    document.addEventListener('dragover', function(e) {
      if (!charmDragging) return;
      e.preventDefault();
      var y = e.clientY, h = window.innerHeight, edge = 110, speed = 20;
      if (y < edge) window.scrollBy(0, -speed);
      else if (y > h - edge) window.scrollBy(0, speed);
    });

    // Add to cart
    document.getElementById('bldATC').addEventListener('click', addToCart);
    document.getElementById('bldMobileATC').addEventListener('click', addToCart);

    // Mobile toggle
    document.getElementById('bldMobileToggle').addEventListener('click', function() {
      document.getElementById('bldMobileBar').classList.toggle('expanded');
    });

    // Guide ("How it works")
    // Hidden by default in the HTML so returning visitors don't see it flash up
    // and vanish. We SHOW it here only on the first visit, and expose a
    // "How it works" button so it can be reopened any time.
    var guideEl = document.getElementById('bldGuide');
    function showGuide() { if (guideEl) guideEl.style.display = 'flex'; }
    function hideGuide() { if (guideEl) guideEl.style.display = 'none'; }
    document.getElementById('bldGuideStart').addEventListener('click', function() {
      hideGuide();
      localStorage.setItem('ct-builder-guided', '1');
      setTimeout(nudgeCats, 350);   // demo the category scroll once the builder is visible
    });
    var guideOpen = document.getElementById('bldGuideOpen');
    if (guideOpen) guideOpen.addEventListener('click', showGuide);
    /* dismiss by tapping the backdrop or pressing Escape */
    if (guideEl) guideEl.addEventListener('click', function(e) { if (e.target === guideEl) hideGuide(); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') hideGuide(); });
    if (!localStorage.getItem('ct-builder-guided')) showGuide();
    else setTimeout(nudgeCats, 500);   // returning visitors skip the guide — still hint the scroll

    // Zoom = full-bracelet view (rotate vertical, fit to screen)
    document.getElementById('bldZoomIn').addEventListener('click', function() {
      document.getElementById('bldBraceletWrap').classList.add('zoomed');
      document.body.style.overflow = 'hidden';
      applyZoomView();
    });
    document.getElementById('bldZoomClose').addEventListener('click', function() {
      document.getElementById('bldBraceletWrap').classList.remove('zoomed');
      document.body.style.overflow = '';
      clearZoomView();
      renderBracelet();          /* restores normal layout via fitBracelet */
      centerActiveSlot(false);
    });

    // Reset
    document.getElementById('bldReset').addEventListener('click', function() {
      if (!state.slots.some(function(s) { return s !== null; })) return;
      if (!confirm('Start over? This will clear your current bracelet.')) return;
      state.base = 'silver';
      state.baseVariantId = SILVER_VARIANT;
      state.size = 18;
      state.slots = new Array(getSlotCount(18)).fill(null);
      selectedSlot = -1;
      document.querySelectorAll('.ct-bld-color-btn').forEach(function(b) {
        b.classList.toggle('active', b.dataset.base === 'silver');
      });
      document.getElementById('bldSize').value = 18;
      localStorage.removeItem('ct-builder-draft');
      update();
    });

    // Draft
    document.getElementById('bldDraftContinue').addEventListener('click', function() {
      restoreDraft();
      document.getElementById('bldDraftBanner').classList.remove('show');
      document.getElementById('bldGuide').style.display = 'none';
    });
    document.getElementById('bldDraftNew').addEventListener('click', function() {
      localStorage.removeItem('ct-builder-draft');
      document.getElementById('bldDraftBanner').classList.remove('show');
    });
  }

  /* ═══ ADD TO CART ═══ */
  function addToCart() {
    var items = [{ id: parseInt(state.baseVariantId), quantity: 1, properties: { '_builder': 'true' } }];
    state.slots.forEach(function(s, i) {
      if (isPrimary(s)) items.push({ id: parseInt(s.variantId), quantity: 1, properties: { '_builder_slot': '' + (i+1) } });
    });

    var btn = document.getElementById('bldATC');
    var mBtn = document.getElementById('bldMobileATC');
    btn.disabled = true; btn.textContent = 'Adding...';
    mBtn.disabled = true; mBtn.textContent = 'Adding...';

    /* If the theme has a cart drawer, ask /cart/add.js to return the drawer +
       cart-bubble section HTML so we can refresh and open the drawer (Dawn pattern). */
    var cartDrawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map(function(s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      btn.innerHTML = 'Added! ✓'; mBtn.textContent = 'Added! ✓';
      setTimeout(function() {
        btn.disabled = false;
        btn.innerHTML = 'ADD TO CART <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
        mBtn.disabled = false; mBtn.textContent = 'ADD TO CART';
      }, 2000);
      if (cartDrawer && data && data.sections && typeof cartDrawer.renderContents === 'function') {
        /* refreshes the drawer contents + cart bubble, then opens the drawer */
        cartDrawer.renderContents(data);
      } else {
        /* no drawer (e.g. notification cart) → just refresh the count bubble */
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          document.querySelectorAll('.cart-count-bubble span').forEach(function(el) { el.textContent = cart.item_count; });
          document.querySelectorAll('.cart-count-bubble').forEach(function(el) { el.style.display = ''; });
        });
      }
      localStorage.removeItem('ct-builder-draft');
    })
    .catch(function() {
      btn.disabled = false; btn.innerHTML = 'Error — try again';
      mBtn.disabled = false; mBtn.textContent = 'Error — try again';
    });
  }

  /* ═══ DRAFT PERSISTENCE ═══ */
  function saveDraft() {
    try {
      localStorage.setItem('ct-builder-draft', JSON.stringify({
        base: state.base, baseVariantId: state.baseVariantId,
        size: state.size, slots: state.slots, ts: Date.now()
      }));
    } catch(e) {}
  }

  function checkDraft() {
    try {
      var draft = JSON.parse(localStorage.getItem('ct-builder-draft'));
      if (draft && draft.slots && draft.slots.some(function(s) { return s !== null; })) {
        if (Date.now() - draft.ts < 7 * 24 * 60 * 60 * 1000) {
          document.getElementById('bldDraftBanner').classList.add('show');
        }
      }
    } catch(e) {}
  }

  function restoreDraft() {
    try {
      var draft = JSON.parse(localStorage.getItem('ct-builder-draft'));
      if (!draft) return;
      state.base = draft.base || 'silver';
      state.baseVariantId = draft.baseVariantId || SILVER_VARIANT;
      state.size = draft.size || 18;
      state.slots = draft.slots || new Array(getSlotCount(state.size)).fill(null);

      // Update UI controls
      document.querySelectorAll('.ct-bld-color-btn').forEach(function(b) {
        b.classList.toggle('active', b.dataset.base === state.base);
      });
      document.getElementById('bldSize').value = state.size;
      update();
    } catch(e) {}
  }

  /* ═══ START ═══ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
